// Mirrors TERMINAL_REQUEST_STATUSES in backend/src/api/requests_api.py.
// Once a request reaches one of these statuses it has been published/
// finalized and its fields are locked — the backend rejects PUT
// /requests/:id and /requests/:id/fields for these too, this just keeps
// the UI from offering an edit action that would fail.
export const TERMINAL_REQUEST_STATUSES = new Set([
  'approved',
  'rejected',
  'failed',
  'completed',
  'cancelled',
])

export function isRequestLocked(status) {
  return TERMINAL_REQUEST_STATUSES.has(status)
}
